import * as Yup from 'yup';
import SelectQuestion from '../SelectQuestion/SelectQuestion';
import { createLocalizedOptions } from '../../pages/root/App';
import messages from './messages';
import siteMessages from '../../pages/root/siteMessages';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { weeklyPlaytimes } from '../../utils/constants';

interface Props {
  values: any;
  errors: any;
  setFieldValue: any;
  updateSchema: (value: any) => void;
}

const WeeklyPlaytime = ({
  values,
  errors,
  setFieldValue,
  updateSchema
}: Props) => {
  const intl = useIntl();

  const weeklyPlaytimesOptions = createLocalizedOptions(
    weeklyPlaytimes,
    messages
  );

  useEffect(() => {
    const weeklyPlaytimeSchema = {
      weeklyPlaytimeId: Yup.number().positive(
        intl.formatMessage({ ...siteMessages.FIELD_REQUIRED })
      )
    };
    updateSchema(weeklyPlaytimeSchema);
  }, []);

  return (
    <SelectQuestion
      controlId="weeklyPlaytimeId"
      label={intl.formatMessage({ ...messages.weeklyPlaytimes })}
      isMulti={false}
      options={weeklyPlaytimesOptions}
      value={values.weeklyPlaytimeId}
      error={errors.weeklyPlaytimeId}
      setFieldValue={setFieldValue}
    />
  );
};

export default WeeklyPlaytime;
